import React from 'react';
import { useLanguage } from '../utils/languageContext.js';
import { getTranslation } from '../utils/translate.js';

const NotFound = () => {
    const { language } = useLanguage();
    
    return (
        <div className="flex justify-center items-center h-screen">
            <h1 className="text-4xl text-red-600 font-bold">{getTranslation('common.pageNotFound', language)}</h1>
        </div>
    );
};

export default NotFound;
